export default "__VITE_ASSET__bTH4h0X1__"